export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
  } catch { return iso; }
}

/**
 * Display the ServiceNow number when the record has been synced to SN
 * (sn_number populated by the backend after a successful sc_request/incident create),
 * else fall back to the Flexspace-local req_number.
 * This keeps the numbers matching what leadership sees in the ServiceNow UI.
 */
export function displayReqNumber(item) {
  if (!item) return "";
  return item.sn_number || item.req_number || "";
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
}

export function statusColor(status) {
  switch (status) {
    case "Submitted": return { bg: "#EEF2FF", fg: "#3730A3", dot: "#4F46E5" };
    case "Pending Approval": return { bg: "#FFF7ED", fg: "#9A3412", dot: "#EA580C" };
    case "In Progress": return { bg: "#FEF3C7", fg: "#92400E", dot: "#D97706" };
    case "Approved": return { bg: "#DBEAFE", fg: "#1E40AF", dot: "#1E40AF" };
    case "Fulfilled": return { bg: "#DCFCE7", fg: "#166534", dot: "#16A34A" };
    case "Rejected": return { bg: "#FEE2E2", fg: "#991B1B", dot: "#DC2626" };
    case "In Use": return { bg: "#DCFCE7", fg: "#166534", dot: "#16A34A" };
    case "In Repair": return { bg: "#FEF3C7", fg: "#92400E", dot: "#D97706" };
    case "Available": return { bg: "#DBEAFE", fg: "#1E40AF", dot: "#1E40AF" };
    default: return { bg: "#F1F5F9", fg: "#475569", dot: "#64748B" };
  }
}
